import { render, staticRenderFns } from "./SubtitleUploadWrapper.vue?vue&type=template&id=24983616&scoped=true"
import script from "./SubtitleUploadWrapper.vue?vue&type=script&lang=js"
export * from "./SubtitleUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24983616",
  null
  
)

export default component.exports